import { IframeDataResponseType, IframeDataAdaptedType } from '../types';

const iframeDataAdapter = (value: IframeDataResponseType): IframeDataAdaptedType => {
  if ('ThreeDSMethodData' in value) {
    const {
      Action,
      TermUrl,
      ThreeDSMethodData,
      ThreeDSMethodNotificationUrl,
      ThreeDSServerTransID,
    } = value;

    return {
      action: Action,
      threeDSMethodData: ThreeDSMethodData,
      TermUrl,
      ThreeDSMethodNotificationUrl,
      ThreeDSServerTransID,
      step: 'threeDS2Auth',
    };
  }

  if ('PaReq' in value) {
    const { Action, MD, PaReq, TermUrl } = value;

    return {
      action: Action,
      MD,
      PaReq,
      TermUrl,
      step: 'threeDS1',
    };
  }

  const { action, cReq, threeDSSessionData } = value;

  return {
    action,
    creq: cReq,
    threeDSSessionData,
    step: 'threeDS2Pay',
  };
};

export default iframeDataAdapter;
